import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { formatFileName } from '../utils';

const ATTACHMENT_STATUS_OPTIONS = [
  { value: 1, label: 'Reject' },
  { value: 2, label: 'Resolve' },
  // { value: 3, label: 'Required' },
];

const CancelAttachmentDialog = ({
  open,
  selectedLead,
  attachment,
  processing = false,
  onClose,
  onSubmit,
}) => {
  const [status, setStatus] = useState(1);
  const [comment, setComment] = useState('');

  const handleClose = () => {
    setStatus(1);
    setComment('');
    onClose();
  };

  const handleSubmit = () => {
    if (!comment.trim()) return;
    onSubmit({ status, comment: comment.trim() });
  };

  const fileLabel = attachment ? formatFileName(attachment, 0) : 'Attachment';

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Update Attachment Status</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
          <Typography variant="body2" color="text.secondary">
            Lead: {selectedLead?.name || selectedLead?.dba_name || '—'}
          </Typography>
          <Typography variant="body2" color="text.secondary" noWrap title={fileLabel}>
            File: {fileLabel}
          </Typography>
          <FormControl fullWidth disabled={processing}>
            <InputLabel id="attachment-status-label">Status *</InputLabel>
            <Select
              labelId="attachment-status-label"
              label="Status *"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              {ATTACHMENT_STATUS_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Comment *"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            multiline
            rows={4}
            fullWidth
            placeholder="Enter comment for this attachment"
            disabled={processing}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} disabled={processing}>
          Close
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color={status === 1 ? 'error' : status === 3 ? 'warning' : 'primary'}
          disabled={!comment.trim() || processing}
          startIcon={processing ? <CircularProgress size={18} color="inherit" /> : null}
        >
          {processing ? 'Submitting...' : 'Submit'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelAttachmentDialog;
